export const AUTHORING_ACCESS_ALL_WORK_PACKAGES_DEMAND = "authoring:access-all-work-packages"
export const AUTHORING_MANAGE_GLOBAL_ROLES_DEMAND = "authoring:manage-global-roles"
export const AUTHORING_MANAGE_GLOBAL_USERS_DEMAND = "authoring:manage-global-users"
export const AUTHORING_MANAGE_LEGISLATION_DEMAND = "authoring:manage-legislation"
export const AUTHORING_MANAGE_MAINTENANCE_LIBRARY_DEMAND = "authoring:manage-maintenance-library"
export const AUTHORING_MANAGE_MACROS_DEMAND = "authoring:manage-macros"
export const AUTHORING_MANAGE_WORK_PACKAGE_ROLES_DEMAND = "authoring:manage-work-package-roles"
export const AUTHORING_MANAGE_WORK_PACKAGE_USERS_DEMAND = "authoring:manage-work-package-users"
export const AUTHORING_MANAGE_WORK_PACKAGES_DEMAND = "authoring:manage-work-packages"
export const AUTHORING_EDIT_SCHEDULES_DEMAND = "authoring:edit-schedules"
export const AUTHORING_CREATE_SCHEDULES_DEMAND = "authoring:create-schedules"
export const AUTHORING_PUSH_TO_LEGACY_DEMAND = "authoring:push-to-legacy"
export const AUTHORING_PUBLISH_DEMAND = "authoring:publish"
export const AUTHORING_MANAGE_PUBLISHED_DATES_DEMAND = "authoring:manage-published-dates"
export const AUTHORING_REVIEW_SCHEDULES_DEMAND = "authoring:review-schedules"
export const AUTHORING_UNLOCK_WORK_PACKAGE_DEMAND = "authoring:unlock-work-package"
export const AUTHORING_GENERATE_SCHEDULE_COMMENTARY_DEMAND = "authoring:generate-schedule-commentary"
export const AUTHORING_REVIEW_COMPONENT_DEMAND = "authoring:review-component"
export const AUTHORING_ACCESS_PROJECT_BRIDGE_DEMAND = "authoring:access-project-bridge"
export const AUTHORING_ARCHIVE_WORK_PACKAGES_DEMAND = "authoring:archive-work-packages"
export const AUTHORING_ARCHIVE_INCOMPLETE_WORK_PACKAGES_DEMAND = "authoring:archive-incomplete-work-packages"
export const AUTHORING_VIEW_ARCHIVED_WORK_PACKAGES_DEMAND = "authoring:view-archived-work-packages"
